import React from "react";

const Footer = () => {

  return (
    <>
      <div className="google-reviews">
        <img src="/images/google_data.png" alt=""></img>
      </div>
    </>
  );
};

export default Footer;
